import axios from "axios";

const apiUrl = {
  baseURL: process.env.REACT_APP_API_URL
  // baseURL: "http://localhost:4044", //dev URL
  // baseURL: "https://kmexample.com", //local test URL
  // baseURL: "https://km2027example.com", //local test 2027 URL
  // baseURL: "https://km2027example.com", //local test URL
  // baseURL: "http://192.168.20.64", //TEST URL
  // baseURL: "http://185.61.6.82", //TEST URL publ
  // baseURL: "https://komitet-test.wrotapodlasia.pl", //TEST domain URL publ
  // baseURL: "https://komitet-test2027.wrotapodlasia.pl", //TEST 2027 domain URL publ
  // baseURL: "https://komitet2020.wrotapodlasia.pl", //PROD domain URL publ
  // baseURL: "http://localhost", //dev Docker
  // headers: {'Access-Control-Allow-Origin': '*'}
}

const instance = axios.create(apiUrl);

instance.defaults.timeout = 60000;

const apiEndpoints = {
  login: { path: "/api/auth/loginJwt" },
  logout: { path: "/api/auth/logoutJwt" },
  passwordReset: { path: "/api/auth/password" },
  passwordActivation: { path: "/api/auth/password/activation" },
  passwordChangeValidation: { path: "/api/auth/password/validation" },
  passwordChange: { path: "/api/auth/password" },
  passwordChangeLogged: { path: "/api/auth/password/logged" },
  getLoggedUser: { path: "/api/auth/user" },
  getMyAccountUser: { path: "/api/auth/myaccount" },
  checkAuthorized: { path: "/api/auth/authorized" },
  setConsent: { path: "/api/auth/consent" },
  setCurrentProfile: { path: "/api/auth/profile" },
  getDocuments: { path: "/api/documents/" },
  getDocumentsBySiblingId: { path: "/api/documents/sibling/" },
  addDocument: { path: "/api/documents/document" },
  updateDocument: { path: "/api/documents/document" },
  getDocumentDetails: { path: "/api/documents/document/" },
  addFolder: { path: "/api/documents/folder" },
  getFolderDetails: { path: "/api/documents/folder/" },
  updateFolder: { path: "/api/documents/folder" },
  deleteDocuments: { path: "/api/documents/" },
  setDocumentsStatus: { path: "/api/documents/status" },
  setDocumentsPublicAccess: { path: "/api/documents/access" },
  structMove: { path: "/api/documents/struct/move" },
  documentFileData: { path: "/api/documents/file/" },
  uploadFileDocument: { path: "/api/documents/filedocument"},
  setCommitteeAttendanceStatus: { path: "/api/documents/attendances/status" },
  setCommitteeAttendanceConfirmation: { path: "/api/documents/attendances/confirm" },
  setCommitteeAttendanceConfirmationForUser: { path: "/api/documents/attendances/admin/confirm" },
  getCommitteeAttendancePreview: { path: "/api/documents/attendances/" },
  getCommitteeAttendanceUsers: { path: "/api/documents/attendances/users" },
  getCommitteeAttendancesExcel: { path: "/api/documents/attendances/excel/" },
  confirmAttendanceLink: { path: "/api/documents/attendances/confirm/link" },
  searchDocumentFiles: { path: "/api/documents/search/files" },
  getUsers: { path: "/api/users" },
  getUsersExcel: { path: "/api/users/excel" },
  getUsersConsentExcel: { path: "/api/users/excelconsent" },
  addUser: { path: "/api/users" },
  getUserDetails: { path: "/api/users/" },
  getUserChangesDetails: { path: "/api/users/datachange/" },
  updateUser: { path: "/api/users" },
  deleteUser: { path: "/api/users" },
  getProfiles: { path: "/api/users/profiles" },
  getProfilesPermissions: { path: "/api/users/profiles/permissions" },
  addProfile: { path: "/api/users/profiles" },
  getProfileDetails: { path: "/api/users/profiles/" },
  updateProfile: { path: "/api/users/profiles" },
  deleteProfiles: { path: "/api/users/profiles" },
  getSidesRepresented: { path: "/api/admin/dictionaries/siderepresented" },
  addSideRepresented: { path: "/api/admin/dictionaries/siderepresented" },
  getSideRepresentedDetails: { path: "/api/admin/dictionaries/siderepresented/" },
  deleteSidesRepresented: { path: "/api/admin/dictionaries/siderepresented" },
  updateSideRepresented: { path: "/api/admin/dictionaries/siderepresented" },
  getAnswerOption: { path: "/api/admin/dictionaries/answeroption" },
  addAnswerOption: { path: "/api/admin/dictionaries/answeroption" },
  getAnswerOptionDetails: { path: "/api/admin/dictionaries/answeroption/" },
  deleteAnswerOption: { path: "/api/admin/dictionaries/answeroption" },
  updateAnswerOption: { path: "/api/admin/dictionaries/answeroption" },
  getMessageType: { path: "/api/admin/dictionaries/messagetype" },
  addMessageType: { path: "/api/admin/dictionaries/messagetype" },
  getMessageTypeDetails: { path: "/api/admin/dictionaries/messagetype/" },
  deleteMessageType: { path: "/api/admin/dictionaries/messagetype" },
  updateMessageType: { path: "/api/admin/dictionaries/messagetype" },
  getInstitutions: { path: "/api/admin/dictionaries/institution" },
  addInstitution: { path: "/api/admin/dictionaries/institution" },
  getInstitutionDetails: { path: "/api/admin/dictionaries/institution/" },
  deleteInstitutions: { path: "/api/admin/dictionaries/institution" },
  updateInstitution: { path: "/api/admin/dictionaries/institution" },
  getFunctions: { path: "/api/admin/dictionaries/function" },
  addFunction: { path: "/api/admin/dictionaries/function" },
  getFunctionDetails: { path: "/api/admin/dictionaries/function/" },
  deleteFunctions: { path: "/api/admin/dictionaries/function" },
  updateFunction: { path: "/api/admin/dictionaries/function" },
  getWorkingGroups: { path: "/api/admin/dictionaries/workgroup" },
  addWorkingGroup: { path: "/api/admin/dictionaries/workgroup" },
  getWorkingGroupDetails: { path: "/api/admin/dictionaries/workgroup/" },
  deleteWorkingGroups: { path: "/api/admin/dictionaries/workgroup" },
  updateWorkingGroup: { path: "/api/admin/dictionaries/workgroup" },
  getConfigurationValue: { path: "/api/admin/configuration/" },
  setConfigurationValue: { path: "/api/admin/configuration" },
  getEventLog: { path: "/api/admin/logs/eventlog" },
  getEventLogExcel: { path: "/api/admin/logs/eventlog/excel" },
  getIllegalAccessLog: { path: "/api/admin/logs/eventillegalaccess" },
  getLoggedInUsers: { path: "/api/admin/loggedinusers" },
  getSystemInfo: { path: "/api/admin/systeminfo" },
  downloadSystemDocument: { path: "/api/admin/system/document/" },
  getNews: { path: "/api/news" },
  addNews: { path: "/api/news" },
  deleteNews: { path: "/api/news" },
  getNewsDetails: { path: "/api/news/" },
  getNewsPreviewDetails: { path: "/api/news/preview/" },
  getNewsByStatusKey: { path: "/api/news/status/" },
  getCalendarEvents: { path: "/api/calendar" },
  getCalendarEventDetails: { path: "/api/calendar/event/" },
  createCalendarEvent: { path: "/api/calendar" },
  updateCalendarEvent: { path: "/api/calendar" },
  deleteCalendarEvent: { path: "/api/calendar" },
  getCalendarInfo: { path: "/api/calendar/events/count" },
  setNewsPublishedStatus: { path: "/api/news/status/published" },
  setNewsArchivedStatus: { path: "/api/news/status/archived" },
  copyNewsAsDraft: { path: "/api/news/copy" },
  uploadNewsImage: { path: "/api/news/image" },
  uploadNewsAttachment: { path: "/api/news/attachment/" },
  getNewsEditDetails: { path: "/api/news/edit/" },
  updateNews: { path: "/api/news" },
  setPublishedNewsPositionUp: { path: "/api/news/published/position/up" },
  setPublishedNewsPositionDown: { path: "/api/news/published/position/down" },
  getManagmentVotings: { path: "/api/vote/management/" },
  addVoting: { path: "/api/vote/management/voting" },
  updateVoting: { path: "/api/vote/management/voting" },
  cancelVote: { path: "/api/vote/management/voting/vote" },
  deleteVotings: { path: "/api/vote/management" },
  getVotingsByStatus: { path: "/api/vote/votings/" },
  getVotingUserDetails: { path: "/api/vote/votings/vote/" },
  getVotingInfo: { path: "/api/vote/votings/count" },
  getVotingAdminDetails: { path: "/api/vote/management/voting/vote/" },
  storeVoteForUser: { path: "/api/vote/votings/vote" },
  storeAdminVoteForUser: { path: "/api/vote/management/voting/vote" },
  getVotingDetails: { path: "/api/vote/management/voting/" },
  getVotingBasicDetails: { path: "/api/vote/management/voting/basic/" },
  getVotingPreviewDetails: { path: "/api/vote/management/voting/preview/" },
  getVotesHistory: { path: "/api/vote/management/voting/vote/history/" },
  getVotingStatusChanges: { path: "/api/vote/management/voting/status/changes/" },
  setVotingStatus: { path: "/api/vote/management/voting/status" },
  getVotingVotesExcel: { path: "/api/vote/management/voting/vote/excel/" },
  getMailings: { path: "/api/mailing" },
  addMailing: { path: "/api/mailing" },
  updateMailing: { path: "/api/mailing" },
  sendMailing: { path: "/api/mailing/mailing" },
  getMailingPreviewDetails: { path: "/api/mailing/" },
  deleteMailings: { path: "/api/mailing" },
  sendContactEmail: { path: "/api/mailing/contact" }
};

const apiGetRequest = (endpoint, withCredentials) => {
  return instance
    .get(`${endpoint}`, withCredentials ? { withCredentials: true } : {})
    .then((response) => {
      return response.data;
    });
};

const apiGetByIdRequest = (endpoint, id, withCredentials) => {
  return instance
    .get(`${endpoint}${id}`, withCredentials ? { withCredentials: true } : {})
    .then((response) => {
      return response.data;
    });
};

const apiPostRequest = (endpoint, requestData, withCredentials) => {
  return instance
    .post(
      endpoint,
      requestData,
      withCredentials ? { withCredentials: true } : {}
    )
    .then((response) => {
      return response.data;
    });
};

const apiPostCustomTimeoutRequest = (endpoint, requestData, withCredentials, timeout) => {
  return instance
    .post(
      endpoint,
      requestData,
      {
        ...(withCredentials ? { withCredentials: true } : {}),
        timeout: timeout
      }
    )
    .then((response) => {
      return response.data;
    });
};

 const apiPostWithHeadersRequest = (endpoint, requestData, headers, withCredentials) => {
  return instance
    .post(
      endpoint,
      requestData,
      {
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
        headers : headers
      },
      withCredentials ? true  : false
    )
    .then((response) => {
      return response.data;
    });
};

const apiPutRequest = (endpoint, requestData, withCredentials) => {
  return instance
    .put(
      endpoint,
      requestData,
      withCredentials ? { withCredentials: true } : {}
    )
    .then((response) => {
      return response.data;
    });
};

const apiPutCustomTimeoutRequest = (endpoint, requestData, withCredentials, timeout) => {
  return instance
    .put(
      endpoint,
      requestData,
      {
        ...(withCredentials ? { withCredentials: true } : {}),
        timeout: timeout
      }
    )
    .then((response) => {
      return response.data;
    });
};

const apiDeleteRequest = (endpoint, requestData, withCredentials) => {
  return instance
    .delete(endpoint,
      withCredentials
        ? { data: requestData, withCredentials: true }
        : { data: requestData }
    )
    .then((response) => {
      return response.data;
    });
};

const apiDownloadFileData = (endpoint, withCredentials) => {
  return instance
    .get(
      endpoint,
      withCredentials
        ? { responseType: "blob", withCredentials: true }
        : { responseType: "blob" }
    )
    .then((response) => {
      return response.data;
    });
};

export {
  apiEndpoints,
  apiUrl,
  apiGetRequest,
  apiGetByIdRequest,
  apiPostRequest,
  apiPostCustomTimeoutRequest,
  apiPostWithHeadersRequest,
  apiPutRequest,
  apiPutCustomTimeoutRequest,
  apiDeleteRequest,
  apiDownloadFileData,
};
